export enum Health {
  UpToDate = 0,
  UpdatesAvailable = 1,
  Vulnerable = 2,
  UpToDateWithOptionalUpdates = 3,
  Error = 4,
  Unknown = 5
}
